import ArrowDropDownSharpIcon from "@mui/icons-material/ArrowDropDownSharp";
import ArrowDropUpSharpIcon from "@mui/icons-material/ArrowDropUpSharp";
import ManageHistorySharpIcon from "@mui/icons-material/ManageHistorySharp";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import { useEffect, useState } from "react";
import { AssignModal } from "../../Features/Frotend/Ticket/AssignModal/assignModal";
import { StatusModal } from "../../Features/Frotend/Ticket/StatusModal/statusModal";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import no_record from "../Images/norecordfound.jpeg";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import * as moment from "moment";
import { NavLink } from "react-router-dom";
import { Logger } from "../../Logger/Logger";

const TableList = ({
  headerData,
  data,
  actionIcons,
  column,
  sortOrder,
  orderBy,
  setSortedBy,
  setSortedOrder,
  pageNumber,
  isSuperAdmin,
  isAdmin,
  ordering,
  setOrdering,
  handleClick,
  updater,
  setUpdater,
}) => {
  const [modalData, setModalData] = useState({});
  const [open, setOpen] = useState(false);
  const [statusOpen, setStatusOpen] = useState(false);
  

  useEffect(() => {
    setUpdater(!updater);
  }, [open, setOpen, statusOpen, setStatusOpen, pageNumber]);

  const getToolTip = (cellData) => {
    if (cellData?.length >= 20) {
      return (
        <Tooltip title={cellData} placement="top-start">
          <TableCell className="custom-text-14 pr-[0] pl-[16px] border-b-[#F1F1F1] max-w-[120px] whitespace-nowrap overflow-hidden text-ellipsis">
            {cellData}
          </TableCell>
        </Tooltip>
      );
    } else {
      return (
        <TableCell className="custom-text-14 pr-[0] pl-[16px]  border-b-[#F1F1F1] ">
          {cellData}
        </TableCell>
      );
    }
  };
  const tableBodyData = () => {
    return data?.length == 0 ? (
      <TableRow
        className="my-[0] mx-[auto]"
      >
        <TableCell colSpan={column?.length + 1}>
          <div className="flex flex-col justify-center items-center pt-[20px] pb-[20px]">
            {/* <h2 className=" text-[18px] font-bold">
              <span className="text-[#2D62ED]">NO</span> RECORDS FOUND
            </h2> */}

            <div className="pt-[20px] w-[30%] ">
              <img src={no_record} draggable="false" />
            </div>
          </div>
        </TableCell>
      </TableRow>
    ) : (
      data &&
      data?.map((data, index) => {
        return (
          <TableRow className="h-[50px]">
            {column &&
              column.map((v) => {
                {
                  if (
                    v !== "isActive" &&
                    v !== "created_date" &&
                    v !== "updatedAt" &&
                    v !== "durationInDays" &&
                    v !== "adminDetails" &&
                    v !== "startDate" &&
                    v !== "endDate" &&
                    v !== "status" &&
                    v !== "activePlan" &&
                    v !== "activeStatus" &&
                    v !== "siteLocations" &&
                    v !== "firstName"
                  ) {
                    if (data[v]?.length >= 20) {
                      return (
                        <Tooltip title={data[v]} placement="top-start">
                          <TableCell
                            className={`${v !== "email" ? "capitalize" : ""
                              }custom-text-14 pr-[0] border-b-[#F1F1F1] pl-[16px] py-0 max-w-[120px] whitespace-nowrap overflow-hidden text-ellipsis
                             `}
                          >
                            {data[v]}
                          </TableCell>
                        </Tooltip>
                      );
                    } else {
                      return (
                        <Tooltip title={data[v]} placement="top-start">
                          <TableCell
                            className={`${v !== "email" ? "capitalize" : ""
                              }custom-text-14 pr-[0] border-b-[#F1F1F1] pl-[16px] py-0 max-w-[120px] whitespace-nowrap overflow-hidden text-ellipsis
                         `}
                          >
                            {data[v]}
                          </TableCell>
                        </Tooltip>
                      );
                    }
                  } else if (v === "isActive") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1] capitalize">
                        {data[v] === true ? "Active" : "Inactive"}
                      </TableCell>
                    );
                  } else if (v === "activeStatus") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0  border-b-[#F1F1F1] capitalize">
                        {convertToTitleCase(data[v])}
                      </TableCell>
                    );
                  } else if (
                    v === "created_date" ||
                    v === "updatedAt" ||
                    v === "startDate" ||
                    v === "endDate"
                  ) {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1] capitalize">
                        {moment(data[v]).format("MMM DD, YYYY")}
                      </TableCell>
                    );
                  } else if (v === "durationInDays") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1] capitalize">
                        {getFormattedStringFromDays(data[v])}
                      </TableCell>
                    );
                  } else if (v === "adminDetails") {
                    return (
                      <>
                        {getToolTip(data[v].name)}
                        {getToolTip(data[v].email)}

                      </>
                    );
                  } else if (v === "status") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1]  capitalize">
                        {convertToTitleCase(data[v])}
                      </TableCell>
                    );
                  } else if (v === "activePlan") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1] capitalize">
                        {data[v] ? data[v].name : "NA"}
                      </TableCell>
                    );
                  } else if (v === "siteLocations") {
                    let namesarr = data[v].map((e) => e.name + ", ").join("");
                    let finalnames = removeLastComma(namesarr);

                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0 border-b-[#F1F1F1] capitalize">
                        {finalnames}
                      </TableCell>
                    );
                  } else if (v === "firstName") {
                    return (
                      <TableCell className="custom-text-14 pr-[0] pl-[16px] py-0  border-b-[#F1F1F1] capitalize">
                        {data.firstName + " " + data.lastName}
                      </TableCell>
                    );
                  }
                }
              })}
            <TableCell className="custom-text-14 py-0 border-b-[#F1F1F1]">
              {isAdmin || isSuperAdmin ? (
                <Tooltip
                  title={"Assign Ticket"}
                  placement="top-start"
                  className="mr-3 cursor-pointer"
                >
                  <PersonAddAltIcon
                    className={data.status === "Closed" ? "opacity-30 cursor-default" : ""}
                    onClick={() => {
                      setModalData(data);
                      if (data.status !== "Closed") {
                        setOpen(true);
                      }
                    }}
                  ></PersonAddAltIcon>
                </Tooltip>
              ) : (
                <></>
              )}

              <Tooltip
                title={"View Ticket"}
                placement="top-start"
                className="mr-3"
              >
                <span
                  onClick={() => {
                    Logger.debug("onClick ", data);
                  }}
                >
                  <NavLink to={`/secured/viewTicket:${data.id}`} state = {{pageNumber:pageNumber}}>
                    <RemoveRedEyeIcon />
                  </NavLink>
                </span>
              </Tooltip>
              {isAdmin || isSuperAdmin ? (
                <Tooltip
                  title={"Change Status"}
                  placement="top-end"
                  className="mr-3 cursor-pointer"
                >
                  <ManageHistorySharpIcon
                    className={data.status === "Closed" ? "opacity-30 cursor-default" : ""}
                    onClick={() => {
                      Logger.debug("status data", data);

                      if (
                        data.status !== "Closed"
                        // &&
                        // data.status !== "Resolved"
                      ) {
                        setStatusOpen(true);
                      }
                      setModalData(data);
                    }}
                  ></ManageHistorySharpIcon>
                </Tooltip>
              ) : (
                <></>
              )}
            </TableCell>
          </TableRow>
        );
      })
    );
  };

  return (
    <>
     
        <TableContainer
          component={Paper}
          sx={{ borderRadius: "5px"}}
          className="shadow-none border-[0.5px] border-[#F1F1F1] !lg:overflow-auto"
        >
          <Table>
            <TableHead sx={{ boxShadow: 1 }} className="whitespace-nowrap ">
              <TableRow className="h-[50px]">
                {headerData?.map(({ name, value, sorting }) => {
                  return (
                    <TableCell
                      align="left"
                      className="custom-text-14 font-[600] text-[#333333] border-b-[#F1F1F1]
                  pr-[0] pl-[16px] capitalize py-0"
                    >
                      <div className="flex flex-row items-center soting-label">
                        <Typography className="font-[600] custom-text-14 ">
                          {name}
                        </Typography>

                        <div className="soting-icon">
                          {sorting ? (
                            sortOrder == 1 && orderBy === value ? (
                              <div
                                onClick={() => {
                                  setSortedBy(value);
                                  setSortedOrder(-1);
                                  setOrdering(`-${value}`);
                                }}
                              >
                                <ArrowDropUpSharpIcon />
                              </div>
                            ) : (
                              <div
                                onClick={() => {
                                  setSortedBy(value);
                                  setSortedOrder(1);
                                  setOrdering(value);
                                }}
                              >
                                <ArrowDropDownSharpIcon />
                              </div>
                            )
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    </TableCell>
                  );
                })}
              </TableRow>
              <TableRow></TableRow>
            </TableHead>
            <TableBody className="custom-text-14 font-normal text-[#333333] whitespace-nowrap pr-[0] pl-[16px]">
              {tableBodyData()}
            </TableBody>
          </Table>
        </TableContainer>
        {open ? (
          <AssignModal
            modalData={modalData}
            setOpen={setOpen}
            open={open}
          ></AssignModal>
        ) : (
          <div></div>
        )}
        {statusOpen ? (
          <StatusModal
            modalData={modalData}
            setStatusOpen={setStatusOpen}
            statusOpen={statusOpen}
          ></StatusModal>
        ) : (
          <div></div>
        )}
      
    </>
  );
};

function removeLastComma(strng) {
  var n = strng.lastIndexOf(",");
  var a = strng.substring(0, n);
  return a;
}

function convertToTitleCase(str) {
  return str?.replace(/\w\S*/g, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
}

function getFormattedStringFromDays(numberOfDays) {
  let years = Math.floor(numberOfDays / 365);
  let months = Math.floor((numberOfDays % 365) / 30);
  let days = Math.floor((numberOfDays % 365) % 30);
  let yearsDisplay =
    years > 0 ? years + (years == 1 ? " year " : " years ") : "";
  let monthsDisplay =
    months > 0 ? months + (months == 1 ? " month " : " months ") : "";
  let daysDisplay = days > 0 ? days + (days == 1 ? " day" : " days") : "";

  return yearsDisplay + monthsDisplay + daysDisplay;
}

export default TableList;

//npm install -D tailwindcss postcss autoprefixer --legacy-peer-deps
//npx tailwindcss init -p --legacy-peer-deps
//border-b-[#F1F1F1]
